import { Helmet } from "react-helmet";
export default function CustomSoftwarePage() {
  return (

    
    <div className="bg-[#0a0d1f] text-white overflow-hidden">

      

<Helmet>
  <title>
    Custom Software Development Company in India | ERP CRM AI Solutions | SoftCoders
  </title>

  <meta
    name="description"
    content="SoftCoders provides custom software development services including ERP software, CRM systems, AI automation tools, SaaS platforms, cloud applications, and enterprise business solutions."
  />

  <meta
    name="keywords"
    content="
    custom software development,
    software development company,
    ERP software development,
    CRM software development,
    AI software company,
    SaaS application development,
    business automation software,
    enterprise software solutions,
    cloud software development,
    custom ERP software,
    custom CRM solutions,
    web application development,
    mobile app development,
    AI automation systems,
    scalable business software,
    startup software development,
    software solutions company india,
    custom software company india,
    SoftCoders
    "
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="SoftCoders" />
  <meta name="language" content="English" />

  {/* Canonical */}
  <link
    rel="canonical"
    href="https://softcoders.in/custom-software"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Custom Software Development Company | SoftCoders"
  />

  <meta
    property="og:description"
    content="Build powerful ERP, CRM, AI software, SaaS platforms, and automation systems with SoftCoders."
  />

  <meta
    property="og:url"
    content="https://softcoders.in/custom-software"
  />

  <meta property="og:type" content="website" />

  <meta
    property="og:image"
    content="https://softcoders.in/og-image.jpg"
  />

  {/* Twitter SEO */}
  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content="Custom Software Development Company | SoftCoders"
  />

  <meta
    name="twitter:description"
    content="SoftCoders develops ERP systems, CRM software, AI tools, SaaS platforms, and enterprise software solutions."
  />

  <meta
    name="twitter:image"
    content="https://softcoders.in/og-image.jpg"
  />

  {/* GEO SEO */}
  <meta name="geo.region" content="IN-HR" />
  <meta name="geo.placename" content="Sirsa, Haryana" />

  {/* Mobile */}
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1"
  />

  {/* Theme Color */}
  <meta name="theme-color" content="#0a0d1f" />

  {/* Schema */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "SoftwareCompany",
        "name": "SoftCoders",
        "url": "https://softcoders.in",
        "description": "SoftCoders is a custom software development company providing ERP, CRM, AI software, cloud applications, and automation systems.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Sirsa",
          "addressRegion": "Haryana",
          "addressCountry": "India"
        },
        "serviceType": [
          "Custom Software Development",
          "ERP Development",
          "CRM Development",
          "AI Software Development",
          "Business Automation"
        ]
      }
    `}
  </script>
</Helmet>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center px-6 lg:px-20 border-b border-[#4a5fd4]/25">
        <div className="absolute inset-0 bg-gradient-to-br from-[#2d3fb5]/25 via-transparent to-[#6b5ce7]/20 blur-3xl pointer-events-none"></div>

        <div className="relative z-10 max-w-7xl w-full grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 border border-[#4a5fd4]/40 bg-[#4a5fd4]/12 px-4 py-2 rounded-full text-[#8fa3f8] text-sm mb-6 backdrop-blur-xl">
              <span className="w-2 h-2 bg-[#4a5fd4] rounded-full animate-pulse"></span>
              Future Ready Software Solutions
            </div>

            <h1 className="text-5xl md:text-7xl font-black leading-tight tracking-tight">
              Custom
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Software
              </span>
              Development
            </h1>

            <p className="mt-8 text-[#9aa3c2] text-lg leading-8 max-w-2xl">
              SoftCoders builds high-performance custom software solutions for startups,
              enterprises, schools, factories, healthcare, and modern businesses.
              We design scalable digital systems that automate operations,
              increase efficiency, and help brands dominate online.
            </p>

           <div className="flex flex-wrap gap-5">

  {/* WHATSAPP CONSULTATION */}
  <a
    href="https://wa.me/919254147455?text=Hello%20SoftCoders%2C%20I%20want%20a%20free%20consultation."
    target="_blank"
    rel="noopener noreferrer"
    className="
      px-8
      py-4
      rounded-2xl
      bg-gradient-to-r
      from-[#2d3fb5]
      to-[#6b5ce7]
      font-semibold
      text-lg
      hover:scale-105
      transition
      duration-300
      shadow-2xl
      shadow-[#2d3fb5]/40
      inline-flex
      items-center
      justify-center
    "
  >
    Get Free Consultation
  </a>

  {/* INTERNAL PROJECT LINK */}
  <a
    href="/services/web-development"
    className="
      px-8
      py-4
      rounded-2xl
      border
      border-white/20
      hover:bg-white
      hover:text-black
      transition
      duration-300
      text-lg
      inline-flex
      items-center
      justify-center
    "
  >
    View Projects
  </a>

</div>

            <div className="grid grid-cols-3 gap-5 mt-14">
              {[
                ["120+", "Projects"],
                ["99%", "Client Satisfaction"],
                ["24/7", "Support"],
              ].map((item, index) => (
                <div
                  key={index}
                  className="p-5 rounded-3xl border border-[#4a5fd4]/25 bg-[#1a2472]/18 backdrop-blur-xl hover:translate-y-[-5px] transition duration-300"
                >
                  <h3 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#8fa3f8]">{item[0]}</h3>
                  <p className="text-[#9aa3c2] mt-2">{item[1]}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative flex items-center justify-center">
            <div className="absolute w-[500px] h-[500px] rounded-full bg-[#2d3fb5]/20 blur-3xl animate-pulse"></div>

            <div className="relative w-full max-w-lg bg-white/4 border border-[#4a5fd4]/25 rounded-[40px] p-8 backdrop-blur-2xl shadow-2xl shadow-[#2d3fb5]/20 hover:scale-[1.02] transition duration-500">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <p className="text-[#9aa3c2]">Active System</p>
                  <h2 className="text-2xl font-bold mt-2">AI Powered Dashboard</h2>
                </div>
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7]"></div>
              </div>

              <div className="space-y-5">
                <div className="p-5 rounded-2xl bg-black/30 border border-[#4a5fd4]/25 hover:border-[#4a5fd4]/70 transition duration-300">
                  <div className="flex justify-between mb-3">
                    <span>System Performance</span>
                    <span className="text-[#8fa3f8]">98%</span>
                  </div>
                  <div className="w-full h-3 rounded-full bg-white/10 overflow-hidden">
                    <div className="w-[98%] h-full bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7] rounded-full"></div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-5">
                  <div className="p-5 rounded-2xl bg-black/30 border border-[#4a5fd4]/25">
                    <h4 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#8fa3f8]">10X</h4>
                    <p className="text-[#9aa3c2] mt-2">Business Growth</p>
                  </div>
                  <div className="p-5 rounded-2xl bg-black/30 border border-[#4a5fd4]/25">
                    <h4 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#6b5ce7] to-[#8fa3f8]">AI</h4>
                    <p className="text-[#9aa3c2] mt-2">Automation</p>
                  </div>
                </div>

                <div className="p-6 rounded-2xl bg-gradient-to-r from-[#2d3fb5]/20 to-[#6b5ce7]/20 border border-[#4a5fd4]/20">
                  <p className="text-lg leading-8 text-[#c5cde8]">
                    Custom ERP, CRM, AI tools, mobile apps, SaaS platforms,
                    dashboards, automation systems, and enterprise software.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-black">
              Our{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Custom Software
              </span>{" "}
              Services
            </h2>
            <p className="text-[#9aa3c2] max-w-3xl mx-auto mt-6 text-lg leading-8">
              We create modern software architectures focused on speed,
              security, automation, scalability, and business growth.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">
            {[
              { title: "ERP Development", desc: "Advanced ERP systems for schools, factories, hospitals, and enterprises." },
              { title: "CRM Solutions", desc: "Customer management systems with automation and analytics." },
              { title: "AI Software", desc: "AI-based automation systems, chatbots, and smart analytics." },
              { title: "Mobile App Development", desc: "Android and iOS applications with premium UI and fast performance." },
              { title: "Cloud Software", desc: "Secure cloud-based systems with real-time synchronization." },
              { title: "Business Automation", desc: "Reduce manual work and improve operational efficiency." },
            ].map((service, index) => (
              <div
                key={index}
                className="group relative p-8 rounded-[32px] bg-[#1a2472]/18 border border-[#4a5fd4]/25 hover:border-[#4a5fd4]/70 transition duration-500 overflow-hidden hover:-translate-y-3"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-[#2d3fb5]/0 to-[#6b5ce7]/0 group-hover:from-[#2d3fb5]/10 group-hover:to-[#6b5ce7]/10 transition duration-500"></div>

                <div className="relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7] mb-8"></div>
                  <h3 className="text-2xl font-bold mb-5">{service.title}</h3>
                  <p className="text-[#9aa3c2] leading-8">{service.desc}</p>
                  <button className="mt-8 text-[#8fa3f8] font-semibold group-hover:translate-x-2 transition duration-300">
                    Learn More →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-28 px-6 lg:px-20 bg-white/[0.015] border-y border-[#4a5fd4]/25">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-black">
              Development{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Process
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              "Planning & Strategy",
              "UI/UX Design",
              "Development & Testing",
              "Launch & Scaling",
            ].map((step, index) => (
              <div
                key={index}
                className="relative p-8 rounded-[30px] bg-black/30 border border-[#4a5fd4]/25 hover:border-[#4a5fd4]/50 transition duration-300 overflow-hidden"
              >
                {/* Number in bottom-right, purely decorative, behind content */}
                <div className="absolute bottom-2 right-4 text-[100px] font-black text-white/5 leading-none select-none pointer-events-none z-0">
                  0{index + 1}
                </div>
                <h3 className="text-2xl font-bold relative z-10">{step}</h3>
                <p className="text-[#9aa3c2] mt-5 leading-8 relative z-10">
                  Premium workflow focused on business goals, user experience,
                  scalability, and performance.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why SoftCoders */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-black leading-tight">
              Why Businesses Choose
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                SoftCoders
              </span>
            </h2>

            <p className="text-[#9aa3c2] mt-8 leading-8 text-lg">
              SoftCoders is a leading custom software development company focused
              on building modern digital solutions for businesses that want
              automation, growth, and long-term scalability.
            </p>

            <p className="text-[#9aa3c2] mt-6 leading-8 text-lg">
              Our expert developers build ERP software, CRM systems, AI-powered
              applications, cloud software, and enterprise platforms using the
              latest technologies and scalable architecture.
            </p>

            <div className="space-y-5 mt-10">
              {[
                "Custom Business Software Development",
                "Enterprise ERP & CRM Solutions",
                "AI Integration & Automation",
                "Modern UI/UX Design",
                "Secure & Scalable Architecture",
              ].map((point, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-5 rounded-2xl bg-[#1a2472]/18 border border-[#4a5fd4]/25"
                >
                  <div className="w-4 h-4 rounded-full bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7] flex-shrink-0"></div>
                  <span className="text-lg">{point}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#2d3fb5]/20 to-[#6b5ce7]/20 blur-3xl"></div>

            <div className="relative rounded-[40px] border border-[#4a5fd4]/25 bg-[#1a2472]/18 p-10 backdrop-blur-xl">
              <h3 className="text-3xl font-black mb-10">Technology Stack</h3>

              <div className="grid grid-cols-2 gap-5">
                {["React.js", "Node.js", "Next.js", "MongoDB", "Laravel", "Python", "Firebase", "AI APIs"].map(
                  (tech, index) => (
                    <div
                      key={index}
                      className="p-5 rounded-2xl bg-black/35 border border-[#4a5fd4]/25 text-center hover:border-[#4a5fd4]/70 transition duration-300"
                    >
                      <span className="text-lg font-semibold">{tech}</span>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto rounded-[50px] border border-[#4a5fd4]/30 bg-gradient-to-r from-[#2d3fb5]/12 to-[#6b5ce7]/12 p-14 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-radial-gradient from-[#4a5fd4]/15 to-transparent blur-3xl pointer-events-none"></div>

          <div className="relative z-10">
            <h2 className="text-5xl font-black leading-tight">
              Ready To Build Your
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Custom Software?
              </span>
            </h2>

            <p className="text-[#b0b8d8] text-lg max-w-3xl mx-auto mt-8 leading-8">
              Transform your business with intelligent software solutions built
              for speed, automation, and future growth.
            </p>

           <div className="flex flex-wrap justify-center gap-5 mt-10">

  {/* START PROJECT BUTTON */}
  <a
    href="https://wa.me/919254147455?text=Hello%20SoftCoders%2C%20I%20want%20to%20discuss%20my%20project."
    target="_blank"
    rel="noopener noreferrer"
    className="
      px-10
      py-5
      rounded-2xl
      bg-gradient-to-r
      from-[#2d3fb5]
      to-[#6b5ce7]
      text-lg
      font-semibold
      hover:scale-105
      transition
      duration-300
      shadow-2xl
      shadow-[#2d3fb5]/40
      inline-flex
      items-center
      justify-center
    "
  >
    Start Your Project
  </a>

  {/* WHATSAPP CONTACT BUTTON */}
  <a
    href="/contact"
    className="
      px-10
      py-5
      rounded-2xl
      border
      border-white/20
      hover:bg-white
      hover:text-black
      transition
      duration-300
      text-lg
      inline-flex
      items-center
      justify-center
    "
    
  >
    Contact SoftCoders
  </a>

</div>
          </div>
        </div>
      </section>
    </div>
  );
}